import { useApiClient } from '@klareospace/pharos-lib-front-utils';
import type { CreateCustomer, Customer } from '@klareospace/pharos-lib-types';
import type { UseMutationResult } from '@tanstack/react-query';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { createMutationCallbacks } from '@klareospace/pharos-lib-web-utils';

import { createCustomerApi, customerKeys } from '../api';

// ─── Hook ─────────────────────────────────────────────────────────────────────

export function useCreateCustomer(): UseMutationResult<Customer, Error, CreateCustomer> {
  const client = useApiClient('deliveries');
  const api = createCustomerApi(client);
  const queryClient = useQueryClient();

  return useMutation<Customer, Error, CreateCustomer>({
    mutationFn: (params: CreateCustomer): Promise<Customer> => api.createCustomer(params),
    ...createMutationCallbacks({
      invalidateKeys: [customerKeys.all],
      queryClient,
    }),
  });
}
